import React from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import AppSidebar from "@/components/app-sidebar";
import Header from "@/components/ui/Header";

export default function Layout({
  children,
  hideNavigation = false,
  showHeaderSelectors = true,
}: {
  children: React.ReactNode;
  hideNavigation?: boolean;
  showHeaderSelectors?: boolean;
}) {
  // Read persisted sidebar state — defaults to expanded (true) on first visit
  const savedState = localStorage.getItem("sidebar:state");
  const defaultOpen = savedState === null ? true : savedState === "true";

  return (
    <SidebarProvider defaultOpen={defaultOpen} className="flex h-screen w-full">
      {!hideNavigation && <AppSidebar />}
      <div className="flex-1 flex flex-col w-full min-w-0 overflow-hidden">
        {!hideNavigation && <Header showSelectors={showHeaderSelectors} />}
        <main
          className={`flex-1 ${hideNavigation ? "p-0" : "p-2"} bg-muted overflow-auto`}
        >
          {children}
        </main>
      </div>
    </SidebarProvider>
  );
}